module.exports = __webpack_public_path__ + "static/media/dinner-takes-all.5f310c61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2020-06-06/dinner-takes-all.jpg
// module id = 826
// module chunks = 0